import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// @ts-ignore
import App from './App.jsx';
// @ts-ignore
import { AuthProvider } from './auth/AuthProvider.jsx';
// @ts-ignore
import { ProtectedRoute } from './auth/ProtectedRoute.jsx';
// @ts-ignore
import { APP_TAB_IDS } from './constants/tabs.js';
// @ts-ignore
import { UrlStateProvider } from './url';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ProtectedRoute>
        <UrlStateProvider knownPages={APP_TAB_IDS}>
          <App />
        </UrlStateProvider>
      </ProtectedRoute>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
